import React from 'react';
import { Link } from 'react-router-dom';

function ShippingPolicy() {
  return (
    <>
      <section class="contact-info-area pt-100 pb-70">
        <div class="container">
          <div class="row">
            <div class="col-lg-12 col-sm-12">
              <h2>Shipping Policy</h2>

              <div className="legalSection">
                <ul>
                  <li><i class="flaticon-check"></i>Orders are shipped via registered courier or speed post.</li>
                  <li><i class="flaticon-check"></i>Dispatch occurs within 2 days of order confirmation.</li>
                  <li><i class="flaticon-check"></i>Delivery delays by courier services are not our liability.</li>
                  <li><i class="flaticon-check"></i>Shipping charges, if any, are non-refundable.</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default ShippingPolicy;
